import { apiFetch } from "./api";

export interface VerifyEmailResponse {
	access_token: string;
	expires_at: string;
	user_id: string;
	wallet_address: string;
	email: string;
	referred_by_code: string | null;
	/** Server-authoritative: true iff this verify just created the account. */
	is_new_account?: boolean;
}

export interface MeResponse {
	user_id: string;
	wallet_address: string;
	email: string | null;
	referral_code: string | null;
	referred_by_code: string | null;
	created_at: string;
}

/**
 * Request a 6-digit login code for `email`. The backend answers 200 whether or
 * not the account exists (no enumeration signal); 429 covers every send
 * throttle (60s per-email cooldown, hourly caps).
 */
export function sendEmailCode(email: string): Promise<{ success: boolean }> {
	return apiFetch<{ success: boolean }>("/v1/auth/email/send-code", {
		method: "POST",
		body: { email },
	});
}

/**
 * Verify the emailed code and establish the session. Signup is implicit: the
 * first successful verify creates the account and its server-custodied wallet.
 * The code is a string — leading zeros are significant. 401 = wrong/expired
 * code, 429 = attempts exhausted (a new code must be requested).
 */
export function verifyEmailCode(input: {
	email: string;
	code: string;
	referral_code?: string | null;
}): Promise<VerifyEmailResponse> {
	const body: Record<string, unknown> = {
		email: input.email,
		code: input.code,
	};
	if (input.referral_code) body.referral_code = input.referral_code;

	return apiFetch<VerifyEmailResponse>("/v1/auth/email/verify", {
		method: "POST",
		body,
	});
}

export function fetchMe(): Promise<MeResponse> {
	return apiFetch<MeResponse>("/v1/auth/me", { method: "GET" });
}
